module.exports = __webpack_public_path__ + "static/media/img-mobile-app-bg@3x.efbf77bf.png";